import type { Gap } from '../types'

export const paddingBlock = {
  0: 'shr-py-0',
  0.25: 'shr-py-0.25',
  0.5: 'shr-py-0.5',
  0.75: 'shr-py-0.75',
  1: 'shr-py-1',
  1.25: 'shr-py-1.25',
  1.5: 'shr-py-1.5',
  2: 'shr-py-2',
  2.5: 'shr-py-2.5',
  3: 'shr-py-3',
  3.5: 'shr-py-3.5',
  4: 'shr-py-4',
  8: 'shr-py-8',
  X3S: 'shr-py-0.25',
  XXS: 'shr-py-0.5',
  XS: 'shr-py-1',
  S: 'shr-py-1.5',
  M: 'shr-py-2',
  L: 'shr-py-2.5',
  XL: 'shr-py-3',
  XXL: 'shr-py-3.5',
  X3L: 'shr-py-4',
} as { [key in Gap]: string }

export const paddingInline = {
  0: 'shr-px-0',
  0.25: 'shr-px-0.25',
  0.5: 'shr-px-0.5',
  0.75: 'shr-px-0.75',
  1: 'shr-px-1',
  1.25: 'shr-px-1.25',
  1.5: 'shr-px-1.5',
  2: 'shr-px-2',
  2.5: 'shr-px-2.5',
  3: 'shr-px-3',
  3.5: 'shr-px-3.5',
  4: 'shr-px-4',
  8: 'shr-px-8',
  X3S: 'shr-px-0.25',
  XXS: 'shr-px-0.5',
  XS: 'shr-px-1',
  S: 'shr-px-1.5',
  M: 'shr-px-2',
  L: 'shr-px-2.5',
  XL: 'shr-px-3',
  XXL: 'shr-px-3.5',
  X3L: 'shr-px-4',
} as { [key in Gap]: string }
